module.exports = __webpack_public_path__ + "assets/icon_pause--dark.8e4f68af.svg";